module.exports = require("./ha.d.ts");